import Vue from "vue/dist/vue.common";
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import { required } from 'vuelidate/lib/validators';
import DropdownModern from "../dropdown-modern/dropdown-modern";

const BonusB2bComponent = {
    components: {
        DropdownModern
    },
    props: {
        ajaxUrl: {
            type: String,
            default: ""
        },
        selects: {
            type: Object,
            default: () => {}
        },
        userType: {
            type: String
        },
        urType: {
            type: String
        },
        closable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            fields: {
                userType: {},
                urType: {}
            },
        }
    },
    computed: {
        isAttachedUr() {
            return this.fields.userType.value === "company"
        },
        userTypeOptions() {
            return this.selects.userType || [];
        },
        urTypeOptions() {
            return this.selects.urType || [];
        }
    },
    methods: {
        select(value, field) {
            this.fields[field] = value;
        },
        submit() {
            let data = new FormData(this.$refs.form);
            $.ajax({
				type: 'POST',
				url: this.ajaxUrl,
                data: data,
                dataType: 'json',
                cache: false,
                contentType: false,
                processData: false,
				success: (res)=> {
                    if (res.url) {
                        window.location.href = res.url;
                    } else {
                        window.location.reload();
                    }
				}
			});
        }
    },
    validations() {
        let scheme = {
            fields: {
                userType: { required }
            }
        };
        if (this.isAttachedUr) {
            Object.assign(scheme.fields, {
                urType: { required }
            });
        }
        return scheme;
    },
    created() {
		const typesArr = ["userType", "urType"]
		typesArr.forEach(type => {
		    if (this[type]) {
		        this.fields[type] = this.selects[type].find(select => select.value === this[type]) || {};
		    }
		})
	},
    mounted() {

    },
    unmounted() {
        this.$destroy();
    }
}

export default class BonusB2bModal {
    constructor(el) {
        new Vue({
            el: el,
            components: {
                "bonus-b2b-modal": BonusB2bComponent
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
    }
}
